import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";

interface ResaleTransaction {
  id: string;
  item: string;
  sku: string;
  seller: string;
  sellerEmail: string;
  buyer: string;
  buyerEmail: string;
  price: number;
  status: string;
  date: string;
  condition: string;
}

export const Route = createFileRoute("/programs_/$id_/resale")({
  component: ProgramResale,
});

const MOCK_RESALE_TRANSACTIONS: ResaleTransaction[] = [
  {
    id: "rs-mc-001",
    item: "Ultraboost 22",
    sku: "GX5460",
    seller: "James K.",
    sellerEmail: "james.k@example.com",
    buyer: "Sarah M.",
    buyerEmail: "sarah.m@example.com",
    price: 52.0,
    status: "completed",
    date: "2026-02-19",
    condition: "Good",
  },
  {
    id: "rs-mc-002",
    item: "Forum Low",
    sku: "FY7756",
    seller: "Maria L.",
    sellerEmail: "maria.l@example.com",
    buyer: "Tom W.",
    buyerEmail: "tom.w@example.com",
    price: 68.0,
    status: "completed",
    date: "2026-02-19",
    condition: "Excellent",
  },
  {
    id: "rs-mc-003",
    item: "Samba OG",
    sku: "B75806",
    seller: "Chen R.",
    sellerEmail: "chen.r@example.com",
    buyer: "Alex P.",
    buyerEmail: "alex.p@example.com",
    price: 45.0,
    status: "shipped",
    date: "2026-02-18",
    condition: "Good",
  },
  {
    id: "rs-mc-004",
    item: "Stan Smith",
    sku: "FX5502",
    seller: "Emily D.",
    sellerEmail: "emily.d@example.com",
    buyer: "Jordan B.",
    buyerEmail: "jordan.b@example.com",
    price: 38.0,
    status: "pending",
    date: "2026-02-18",
    condition: "Fair",
  },
  {
    id: "rs-mc-005",
    item: "Gazelle",
    sku: "BB5476",
    seller: "David H.",
    sellerEmail: "david.h@example.com",
    buyer: "Lisa N.",
    buyerEmail: "lisa.n@example.com",
    price: 55.0,
    status: "completed",
    date: "2026-02-18",
    condition: "Good",
  },
  {
    id: "rs-mc-006",
    item: "Superstar",
    sku: "EG4958",
    seller: "Pat C.",
    sellerEmail: "pat.c@example.com",
    buyer: "Robin K.",
    buyerEmail: "robin.k@example.com",
    price: 35.0,
    status: "completed",
    date: "2026-02-17",
    condition: "Fair",
  },
  {
    id: "rs-mc-007",
    item: "ZX 8000",
    sku: "FW4910",
    seller: "Casey M.",
    sellerEmail: "casey.m@example.com",
    buyer: "Riley S.",
    buyerEmail: "riley.s@example.com",
    price: 72.0,
    status: "shipped",
    date: "2026-02-17",
    condition: "Excellent",
  },
  {
    id: "rs-mc-008",
    item: "Continental 80",
    sku: "EE5342",
    seller: "Drew F.",
    sellerEmail: "drew.f@example.com",
    buyer: "Jamie T.",
    buyerEmail: "jamie.t@example.com",
    price: 42.0,
    status: "completed",
    date: "2026-02-17",
    condition: "Good",
  },
  {
    id: "rs-mc-009",
    item: "Handball Spezial",
    sku: "DB3021",
    seller: "Sam G.",
    sellerEmail: "sam.g@example.com",
    buyer: "Quinn H.",
    buyerEmail: "quinn.h@example.com",
    price: 58.0,
    status: "pending",
    date: "2026-02-16",
    condition: "Good",
  },
  {
    id: "rs-mc-010",
    item: "Campus 80s",
    sku: "FZ6154",
    seller: "Avery L.",
    sellerEmail: "avery.l@example.com",
    buyer: "Skyler R.",
    buyerEmail: "skyler.r@example.com",
    price: 48.0,
    status: "completed",
    date: "2026-02-16",
    condition: "Excellent",
  },
  {
    id: "rs-mc-011",
    item: "Ozweego",
    sku: "EE7002",
    seller: "Reese W.",
    sellerEmail: "reese.w@example.com",
    buyer: "Finley J.",
    buyerEmail: "finley.j@example.com",
    price: 50.0,
    status: "shipped",
    date: "2026-02-16",
    condition: "Good",
  },
  {
    id: "rs-mc-012",
    item: "Nite Jogger",
    sku: "EF5404",
    seller: "Sage B.",
    sellerEmail: "sage.b@example.com",
    buyer: "Blake M.",
    buyerEmail: "blake.m@example.com",
    price: 44.0,
    status: "completed",
    date: "2026-02-15",
    condition: "Good",
  },
  {
    id: "rs-mc-013",
    item: "Rivalry Low",
    sku: "EE4657",
    seller: "Morgan P.",
    sellerEmail: "morgan.p@example.com",
    buyer: "Taylor D.",
    buyerEmail: "taylor.d@example.com",
    price: 36.0,
    status: "completed",
    date: "2026-02-15",
    condition: "Fair",
  },
  {
    id: "rs-mc-014",
    item: "Ultraboost 21",
    sku: "FY0378",
    seller: "Jordan K.",
    sellerEmail: "jordan.k@example.com",
    buyer: "Chris L.",
    buyerEmail: "chris.l@example.com",
    price: 62.0,
    status: "pending",
    date: "2026-02-15",
    condition: "Excellent",
  },
  {
    id: "rs-mc-015",
    item: "Yeezy 350 V2",
    sku: "FW3042",
    seller: "Alex T.",
    sellerEmail: "alex.t@example.com",
    buyer: "Dana W.",
    buyerEmail: "dana.w@example.com",
    price: 120.0,
    status: "completed",
    date: "2026-02-14",
    condition: "Good",
  },
  {
    id: "rs-mc-016",
    item: "NMD_R1 V2",
    sku: "FW6410",
    seller: "Kim S.",
    sellerEmail: "kim.s@example.com",
    buyer: "Lee R.",
    buyerEmail: "lee.r@example.com",
    price: 46.0,
    status: "shipped",
    date: "2026-02-14",
    condition: "Good",
  },
  {
    id: "rs-mc-017",
    item: "Terrex Free Hiker",
    sku: "EF6588",
    seller: "Robin A.",
    sellerEmail: "robin.a@example.com",
    buyer: "Pat H.",
    buyerEmail: "pat.h@example.com",
    price: 78.0,
    status: "completed",
    date: "2026-02-14",
    condition: "Excellent",
  },
  {
    id: "rs-mc-018",
    item: "Stan Smith Lux",
    sku: "HP2201",
    seller: "Casey D.",
    sellerEmail: "casey.d@example.com",
    buyer: "Riley M.",
    buyerEmail: "riley.m@example.com",
    price: 54.0,
    status: "completed",
    date: "2026-02-13",
    condition: "Good",
  },
  {
    id: "rs-mc-019",
    item: "Adilette",
    sku: "EG4919",
    seller: "Jamie K.",
    sellerEmail: "jamie.k@example.com",
    buyer: "Drew S.",
    buyerEmail: "drew.s@example.com",
    price: 22.0,
    status: "pending",
    date: "2026-02-13",
    condition: "Fair",
  },
  {
    id: "rs-mc-020",
    item: "Forum Mid",
    sku: "GW6933",
    seller: "Sam L.",
    sellerEmail: "sam.l@example.com",
    buyer: "Quinn R.",
    buyerEmail: "quinn.r@example.com",
    price: 75.0,
    status: "completed",
    date: "2026-02-13",
    condition: "Excellent",
  },
];

function getStatusColor(status: string): string {
  const colors: Record<string, string> = {
    completed: "#00FBA9",
    shipped: "#4A90D9",
    pending: "#A9A9A9",
  };
  return colors[status.toLowerCase()] || "#A9A9A9";
}

function DemoBadge() {
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-full"
      style={{ backgroundColor: "rgba(0,251,169,0.15)", color: "#171717" }}
    >
      Demo Data
    </span>
  );
}

function ProgramResale() {
  const params = Route.useParams() as { id: string };
  const programId = params.id;
  const [search, setSearch] = useState("");
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const filtered = search
    ? MOCK_RESALE_TRANSACTIONS.filter(
        (t) =>
          t.id.toLowerCase().includes(search.toLowerCase()) ||
          t.item.toLowerCase().includes(search.toLowerCase()) ||
          t.seller.toLowerCase().includes(search.toLowerCase()) ||
          t.buyer.toLowerCase().includes(search.toLowerCase()),
      )
    : MOCK_RESALE_TRANSACTIONS;

  const totalFees = MOCK_RESALE_TRANSACTIONS.reduce(
    (sum, t) => sum + t.price * 0.03,
    0,
  );
  const totalGMV = MOCK_RESALE_TRANSACTIONS.reduce(
    (sum, t) => sum + t.price,
    0,
  );

  return (
    <div>
      {/* Breadcrumb */}
      <div
        className="flex items-center gap-2 text-sm mb-6"
        style={{ color: "#A9A9A9" }}
      >
        <Link to="/programs" className="hover:underline">
          Programs
        </Link>
        <span>/</span>
        <Link
          to="/programs/$id"
          params={{ id: programId }}
          className="hover:underline"
        >
          Program
        </Link>
        <span>/</span>
        <span style={{ color: "#171717" }}>Resale</span>
      </div>

      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-4">
          <div
            className="w-12 h-12 flex items-center justify-center"
            style={{ backgroundColor: "#00FBA9" }}
          >
            <ResaleIcon />
          </div>
          <div>
            <h1 className="text-xl font-light" style={{ color: "#171717" }}>
              Resale Transactions
            </h1>
            <p className="text-sm" style={{ color: "#A9A9A9" }}>
              Peer-to-peer marketplace activity
            </p>
          </div>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="card">
          <p className="text-xs mb-1" style={{ color: "#A9A9A9" }}>
            Total GMV
          </p>
          <p className="text-2xl font-light" style={{ color: "#171717" }}>
            ${totalGMV.toLocaleString()}
          </p>
        </div>
        <div className="card">
          <p className="text-xs mb-1" style={{ color: "#A9A9A9" }}>
            Transactions
          </p>
          <p className="text-2xl font-light" style={{ color: "#171717" }}>
            {MOCK_RESALE_TRANSACTIONS.length}
          </p>
        </div>
        <div className="card">
          <p className="text-xs mb-1" style={{ color: "#A9A9A9" }}>
            Avg Sale Price
          </p>
          <p className="text-2xl font-light" style={{ color: "#171717" }}>
            ${Math.round(totalGMV / MOCK_RESALE_TRANSACTIONS.length)}
          </p>
        </div>
        <div
          className="card"
          style={{ border: "1px solid rgba(0,251,169,0.3)" }}
        >
          <p className="text-xs mb-1" style={{ color: "#A9A9A9" }}>
            Transaction Fees
          </p>
          <p className="text-2xl font-light" style={{ color: "#00FBA9" }}>
            ${totalFees.toFixed(2)}
          </p>
          <p className="text-xs mt-1" style={{ color: "#A9A9A9" }}>
            3% per sale
          </p>
        </div>
      </div>

      {/* Table */}
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <h2 className="text-lg font-medium" style={{ color: "#171717" }}>
              Transactions
            </h2>
            <DemoBadge />
          </div>
          <div className="flex items-center gap-3">
            <div className="relative">
              <SearchIcon />
              <input
                type="text"
                placeholder="Search by ID, item, seller, buyer..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="pl-9 pr-4 py-2 text-sm border rounded-lg w-72"
                style={{
                  borderColor: "rgba(169,169,169,0.3)",
                  backgroundColor: "#FFFFFF",
                }}
              />
            </div>
            <span className="text-sm" style={{ color: "#A9A9A9" }}>
              {filtered.length} results
            </span>
          </div>
        </div>

        <div className="card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr
                  style={{
                    backgroundColor: "#FAFAFA",
                    borderBottom: "1px solid rgba(169,169,169,0.2)",
                  }}
                >
                  <th
                    className="text-left px-4 py-3 font-medium"
                    style={{ color: "#A9A9A9" }}
                  >
                    ID
                  </th>
                  <th
                    className="text-left px-4 py-3 font-medium"
                    style={{ color: "#A9A9A9" }}
                  >
                    Item
                  </th>
                  <th
                    className="text-left px-4 py-3 font-medium"
                    style={{ color: "#A9A9A9" }}
                  >
                    Seller
                  </th>
                  <th
                    className="text-left px-4 py-3 font-medium"
                    style={{ color: "#A9A9A9" }}
                  >
                    Buyer
                  </th>
                  <th
                    className="text-left px-4 py-3 font-medium"
                    style={{ color: "#A9A9A9" }}
                  >
                    Price
                  </th>
                  <th
                    className="text-left px-4 py-3 font-medium"
                    style={{ color: "#00FBA9" }}
                  >
                    Tx Fee
                  </th>
                  <th
                    className="text-left px-4 py-3 font-medium"
                    style={{ color: "#A9A9A9" }}
                  >
                    Status
                  </th>
                  <th
                    className="text-left px-4 py-3 font-medium"
                    style={{ color: "#A9A9A9" }}
                  >
                    Date
                  </th>
                  <th
                    className="text-right px-4 py-3 font-medium"
                    style={{ color: "#A9A9A9" }}
                  ></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((tx) => (
                  <>
                    <tr
                      key={tx.id}
                      className="hover:bg-gray-50 cursor-pointer transition-colors"
                      style={{
                        borderBottom: "1px solid rgba(169,169,169,0.1)",
                      }}
                      onClick={() =>
                        setExpandedId(expandedId === tx.id ? null : tx.id)
                      }
                    >
                      <td className="px-4 py-3">
                        <Link
                          to="/pin/resale/$id"
                          params={{ id: tx.id }}
                          className="font-mono text-xs hover:underline"
                          style={{ color: "#00FBA9" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {tx.id}
                        </Link>
                      </td>
                      <td className="px-4 py-3" style={{ color: "#171717" }}>
                        <div>
                          <p>{tx.item}</p>
                          <p className="text-xs" style={{ color: "#A9A9A9" }}>
                            {tx.sku}
                          </p>
                        </div>
                      </td>
                      <td className="px-4 py-3" style={{ color: "#171717" }}>
                        {tx.seller}
                      </td>
                      <td className="px-4 py-3" style={{ color: "#171717" }}>
                        {tx.buyer}
                      </td>
                      <td
                        className="px-4 py-3 font-medium"
                        style={{ color: "#171717" }}
                      >
                        ${tx.price.toFixed(2)}
                      </td>
                      <td
                        className="px-4 py-3 font-medium"
                        style={{ color: "#00FBA9" }}
                      >
                        ${(tx.price * 0.03).toFixed(2)}
                      </td>
                      <td className="px-4 py-3">
                        <span
                          className="px-2 py-0.5 rounded-full text-xs capitalize"
                          style={{
                            backgroundColor: `${getStatusColor(tx.status)}20`,
                            color: getStatusColor(tx.status),
                          }}
                        >
                          {tx.status}
                        </span>
                      </td>
                      <td className="px-4 py-3" style={{ color: "#A9A9A9" }}>
                        {tx.date}
                      </td>
                      <td className="px-4 py-3 text-right">
                        <ChevronIcon expanded={expandedId === tx.id} />
                      </td>
                    </tr>
                    {expandedId === tx.id && (
                      <tr
                        key={`${tx.id}-detail`}
                        style={{ backgroundColor: "#FAFAFA" }}
                      >
                        <td colSpan={9} className="px-4 py-4">
                          <div className="grid grid-cols-4 gap-6">
                            <div>
                              <h4
                                className="text-xs font-medium mb-2 uppercase tracking-wide"
                                style={{ color: "#A9A9A9" }}
                              >
                                Product
                              </h4>
                              <div className="space-y-2 text-sm">
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Item:
                                  </span>{" "}
                                  {tx.item}
                                </p>
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>SKU:</span>{" "}
                                  {tx.sku}
                                </p>
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Condition:
                                  </span>{" "}
                                  {tx.condition}
                                </p>
                              </div>
                            </div>
                            <div>
                              <h4
                                className="text-xs font-medium mb-2 uppercase tracking-wide"
                                style={{ color: "#A9A9A9" }}
                              >
                                Seller
                              </h4>
                              <div className="space-y-2 text-sm">
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Name:
                                  </span>{" "}
                                  {tx.seller}
                                </p>
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Email:
                                  </span>{" "}
                                  {tx.sellerEmail}
                                </p>
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Payout:
                                  </span>{" "}
                                  <span className="font-medium">
                                    ${(tx.price * 0.97).toFixed(2)}
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div>
                              <h4
                                className="text-xs font-medium mb-2 uppercase tracking-wide"
                                style={{ color: "#A9A9A9" }}
                              >
                                Buyer
                              </h4>
                              <div className="space-y-2 text-sm">
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Name:
                                  </span>{" "}
                                  {tx.buyer}
                                </p>
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Email:
                                  </span>{" "}
                                  {tx.buyerEmail}
                                </p>
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Amount Paid:
                                  </span>{" "}
                                  <span className="font-medium">
                                    ${tx.price.toFixed(2)}
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div>
                              <h4
                                className="text-xs font-medium mb-2 uppercase tracking-wide"
                                style={{ color: "#A9A9A9" }}
                              >
                                Payment Breakdown
                              </h4>
                              <div className="space-y-2 text-sm">
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Sale Price:
                                  </span>{" "}
                                  ${tx.price.toFixed(2)}
                                </p>
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Platform Fee (3%):
                                  </span>{" "}
                                  <span
                                    className="font-medium"
                                    style={{ color: "#00FBA9" }}
                                  >
                                    ${(tx.price * 0.03).toFixed(2)}
                                  </span>
                                </p>
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    Seller Payout:
                                  </span>{" "}
                                  ${(tx.price * 0.97).toFixed(2)}
                                </p>
                                <p>
                                  <span style={{ color: "#A9A9A9" }}>
                                    MasterCard Processing:
                                  </span>{" "}
                                  ${(tx.price * 0.029).toFixed(2)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

// Icons
function ResaleIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#171717"
      strokeWidth="1.5"
    >
      <path
        d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 22V12H15V22" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function SearchIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#A9A9A9"
      strokeWidth="1.5"
      className="absolute left-3 top-1/2 -translate-y-1/2"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="M21 21L16.65 16.65" strokeLinecap="round" />
    </svg>
  );
}

function ChevronIcon({ expanded }: { expanded: boolean }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#A9A9A9"
      strokeWidth="1.5"
      className="transition-transform"
      style={{ transform: expanded ? "rotate(180deg)" : "rotate(0deg)" }}
    >
      <path d="M6 9L12 15L18 9" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
